export default function SecurityAnimation() {
  return (
    <div className="relative w-full h-64 bg-gray-900 rounded-xl overflow-hidden border border-gray-700 shadow-inner flex items-center justify-center">
      {/* Background Grid */}
      <div className="absolute inset-0 grid grid-cols-6 grid-rows-6 gap-0.5 opacity-20">
        {[...Array(36)].map((_, i) => (
          <div key={i} className="bg-blue-500/20" />
        ))}
      </div>

      {/* Scanning Line */}
      <div className="absolute inset-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent z-10 animate-scan drop-shadow-[0_0_8px_rgba(34,211,238,0.8)]" />

      {/* Central Visual */}
      <div className="relative z-20 flex flex-col items-center">
        {/* User Avatar */}
        <div className="relative w-24 h-24 mb-4">
          <div className="absolute inset-0 border-4 border-blue-500/30 rounded-full animate-ping-slow" />
          <div className="absolute inset-0 border-2 border-cyan-400 rounded-full flex items-center justify-center bg-gray-900">
            <svg className="w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
            </svg>
          </div>
          {/* Shield Badge */}
          <div className="absolute -bottom-2 -right-2 bg-green-500 rounded-full p-2 shadow-lg border-2 border-gray-900 animate-bounce-in">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-white font-bold text-lg animate-pulse">Identity Protected</h3>
          <div className="flex items-center justify-center gap-2 mt-2">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500 animate-pulse" />
            <span className="text-green-400 text-xs font-mono uppercase tracking-widest">
              Coverage Active
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scan {
          0% { top: 0%; opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { top: 100%; opacity: 0; }
        }
        @keyframes ping-slow {
          75%, 100% { transform: scale(2); opacity: 0; }
        }
        @keyframes bounce-in {
          0% { transform: scale(0); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
        .animate-scan {
          animation: scan 3s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
        .animate-ping-slow {
          animation: ping-slow 2s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
        .animate-bounce-in {
          animation: bounce-in 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
          animation-delay: 1s;
        }
      `}</style>
    </div>
  )
}
